import styled from 'styled-components';
import { BodyMixin, SitemapMixin } from '@qover/typography';
// @ts-ignore
import triangle from './triangle@10x.png';

export const Container = styled.div`
  background-color: var(--color-card-background-100);
  color: var(--color-text-quote-100);
  max-width: 100%;
  padding: 20px;
  position: relative;
  width: 100%;

  @media (min-width: ${props => props.theme.breakpoints.minWidth.XS}) {
    max-width: 270px;
  }

  > * + * {
    padding-top: 15px;
  }

  &.rounded {
    border-radius: ${({ theme }) => theme.borders.cardRadius};
  }
`;

export const CartContainer = styled(Container)`
  padding: 15px;

  @media (min-width: ${props => props.theme.breakpoints.minWidth.S}) {
    margin-top: 0;
  }

  ::before {
    background-color: transparent;
    background-image: url(${triangle});
    background-size: 18px auto;
    bottom: -5px;
    content: '';
    height: 6px;
    left: 0;
    position: absolute;
    width: 100%;
  }
`;

export const CartHeader = styled.div`
  ${BodyMixin};

  svg {
    height: 20px;
    margin-right: 10px;
    margin-top: 3px;
    max-width: 20px;
    width: 100%;

    g {
      fill: ${({ theme }) => theme.colors.textQuote()};
      fill-opacity: 1;
    }
  }

  display: flex;

  > div {
    display: flex;
    margin-right: auto;

    :last-child:not(:first-child) {
      max-width: 50%;
    }
  }
`;

export const Price = styled.span`
  ${BodyMixin};
  font-weight: bold;
  text-align: right;
`;

export const Divider = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.textQuote(0.2)};
  width: 100%;
`;

export const Footer = styled.div`
  display: flex;
  flex: 1 1 auto;
  justify-content: space-between;
`;

export const TotalPrice = styled.div`
  text-align: right;
`;

export const OptionList = styled.ul`
  margin: 0;
  padding: 15px 0 0;

  > li + li {
    padding-top: 9px;
  }

  li {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }
`;

export const DiscountContainer = styled.div`
  width: 100%;

  > * + * {
    margin-top: 10px;
  }
`;

export const DiscountInnerContainer = styled.div`
  ${SitemapMixin};
  align-items: center;
  background-color: ${props => props.theme.colors.textQuote(0.05)};
  color: ${props => props.theme.colors.secondary()};
  display: flex;
  justify-content: space-between;
  padding: 13px 10px;

  > button {
    color: currentColor;
    background: none;
    padding: 0;
  }

  > span {
    display: flex;
    align-items: center;

    svg {
      margin-right: 5px;
    }
  }

  svg {
    path {
      fill: currentColor;
    }
  }
`;

export const DiscountPopover = styled.span`
  ${BodyMixin};
  color: ${({ theme }) => theme.colors.secondary()};
  cursor: pointer;
  margin: 0;
  text-decoration: underline;

  :hover {
    text-decoration: none;
  }
`;
